import styled from 'styled-components'

export const CustomValidationError = styled.span`
  color: ${({ theme: { palette } }) => palette.danger};
  font-size: ${props => props.theme.font.sizes.small};
`

export const Label = styled.span<{ isLabelBold?: boolean }>`
  display: block;
  font-weight: ${props =>
    props.isLabelBold
      ? props.theme.font.weights.semiBold
      : props.theme.font.weights.regular};
  font-size: ${props => props.theme.font.sizes.medium};
  text-align: left;
`

export const RequiredLabel = styled.p`
  color: ${props => props.theme.palette.dark};
  font-weight: ${props => props.theme.font.weights.light};
  font-size: ${props => props.theme.font.sizes.xsmall};
  font-style: italic;
  margin: 0;
  padding: 0;
`
export const InfoWrapper = styled.div<{ isVerticallyCentered?: boolean }>`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: ${props =>
    props.isVerticallyCentered ? `center` : `flex-start`};
  align-items: flex-start;
`

export const LabelTooltipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`
